import React, { Component } from 'react';
import styled from 'styled-components';
import Navbar from '../../views/shared/navbar/Navbar';
import Footer from '../../views/shared/footer/Footer';
import { Routing } from '../../core/Routing';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as FormManager from '../../reducers/ui/form';
import FormView from '../../views/formView/FormView';
import { gotoPage } from '../../utils/gotoPage';

const PageWrapper = styled.div`
	width: 100%;
	height: 100vh;
`;

type State = {};

class FormPageComponent extends Component<PropsFromRedux, State> {
	state = {};

	componentDidMount(): void {
		// if not through button, redirect
		!this.props.formAccessible && gotoPage(Routing.main.start);
	}

	render() {
		return (
			<PageWrapper>
				<Navbar variant="blue" />
				<FormView />
				<Footer />
			</PageWrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		formAccessible: FormManager.Selectors.getFormAccessible(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const FormPage = connector(FormPageComponent);
export default FormPage;
